import * as React from 'react';
import SVGInline from 'react-svg-inline';

import { HeaderBoxLocale } from './headerBox.locale';
import styles from './HeaderBox.scss';
import SectionTitle from '../../SectionTitle/SectionTitle';
import Map from '../Map/Map';
import mailIcon from '../../Icon/mail.svg';
import phoneIcon from '../../Icon/phone.svg';
import routeIcon from '../../Icon/route.svg';

interface HeaderBoxProps {
  locale: HeaderBoxLocale;
}

class HeaderBox extends React.Component<HeaderBoxProps> {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { locale } = this.props;
    const colClass =
      'col-12 col-md-6 col-xl-3 d-flex justify-content-center justify-content-xl-center mb-4 mb-xl-0';
    const mapContainers = {
      loadingElement: <div style={{ height: `100%`, width: `100%` }} />,
      containerElement: <div style={{ height: `100%`, minHeight: `350px`, width: `100%` }} />,
      mapElement: <div style={{ height: `100%`, width: `100%` }} />,
    };

    return (
      <div className="w-100 pb-8">
        <div className="row">
          <div className="col-12 d-flex justify-content-between flex-wrap mt-8">
            <div className={`${colClass} justify-content-md-start`}>
              <div className={styles.contactBox}>
                <SectionTitle theme="secondaryOnDarkBg">{locale.sales.category}</SectionTitle>
                <div className={styles.rowWrap}>
                  <SVGInline svg={mailIcon} className={styles.icon} />
                  <a href="mailto:sales@peering.cz" className={styles.link}>
                    sales@peering.cz
                  </a>
                </div>

                <div className="mt-4">
                  <SectionTitle theme="secondaryOnDarkBg">{locale.support.category}</SectionTitle>
                  <div className={styles.rowWrap}>
                    <SVGInline svg={mailIcon} className={styles.icon} />
                    <a href="mailto:support@peering.cz" className={styles.link}>
                      support@peering.cz
                    </a>
                  </div>
                  <div className={styles.rowWrap}>
                    <SVGInline svg={phoneIcon} className={styles.icon} />
                    <div>
                      <a href="tel:+420777111297" className={styles.link}>
                        +420 777 111 297
                      </a>
                      <span className={styles.subText}>{locale.support.phoneSupport}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={`${colClass} justify-content-md-end`}>
              <div className={styles.contactBox}>
                <SectionTitle theme="secondaryOnDarkBg">{locale.company.category}</SectionTitle>
                <strong className={styles.companyName}>Peering.cz s.r.o.</strong>
                <p
                  className={styles.text}
                  dangerouslySetInnerHTML={{ __html: locale.company.address }}
                />
                <p
                  className={styles.text}
                  dangerouslySetInnerHTML={{ __html: locale.company.vat }}
                />
                <div className={styles.rowWrap}>
                  <SVGInline svg={mailIcon} className={styles.icon} />
                  <a href="mailto:info@peering.cz" className={styles.link}>
                    info@peering.cz
                  </a>
                </div>
                <div className={styles.rowWrap}>
                  <SVGInline svg={routeIcon} className={styles.icon} />
                  <a
                    href="https://goo.gl/maps/EBgVj1XpBLL2"
                    target="_blank"
                    rel="noopener"
                    className={styles.link}
                  >
                    {locale.company.direction}
                  </a>
                </div>
              </div>
            </div>

            <div className="col-12 col-xl-6 d-flex justify-content-center">
              <div className={styles.map}>
                <Map
                  latLng={{ lat: 50.0732323, lng: 14.4538617 }}
                  zoom={15}
                  googleMapURL={process.env.GOOGLE_MAPS_URLS || ''}
                  marker={true}
                  {...mapContainers}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderBox;



// WEBPACK FOOTER //
// /www/client/src/components/ContactPage/HeaderBox/HeaderBox.tsx